import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import { HelmetProvider } from 'react-helmet-async';

// Pages
import Home from './pages/Home';
import Status from './pages/Status';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Terms from './pages/Terms';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

// Styles
import './App.css';
import 'react-toastify/dist/ReactToastify.css';

// Add this import at the top with other imports
import Privacy from './pages/Privacy';

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <Router>
          <div className="app-container">
            <Navbar />
            <main className="content">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/status/:qrCode" element={<Status />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route 
                  path="/dashboard" 
                  element={
                    <PrivateRoute>
                      <Dashboard />
                    </PrivateRoute>
                  } 
                />
              </Routes>
            </main>
            <Footer />
            <ToastContainer position="top-right" autoClose={5000} />
          </div>
        </Router>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;